<template>
  <v-row align="center">
    <v-col cols="12" md="6" offset-md="3" class="title">
      {{selectedUser.status ? 'Disable' : 'Enable'}} access to the admin dashboard for {{ selectedUser.email }}?
    </v-col>
    <v-col cols="12" md="6" offset-md="3">
      <v-row no-gutters>
        <v-col cols="6" class="text-left">
          <v-btn outlined @click="$emit('close')" small color="red darken-3">
            <v-icon left>fas fa-times</v-icon>
            Cancel
          </v-btn>
        </v-col>
        <v-col cols="6" class="text-right">
          <v-btn outlined @click="changeUserStatus()" small>
            <v-icon left>fas fa-check</v-icon>
            Yes
          </v-btn>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
  export default {
    props: {
      selectedUser: Object
    },
    methods: {
      changeUserStatus(){
        this.$store.dispatch('changeUserStatus', {
          email : this.selectedUser.email,
          id    : this.selectedUser.id,
          status: !this.selectedUser.status
        })
        this.$emit('close')
      }
    }
  }
</script>
